import { useDispatch, useSelector } from 'react-redux';
import {
	useEffect, useRef, useState,
} from 'react';
import { baseShot } from '../stores/reducers/shots';
import { setShotModalShot } from '../stores/actions/shots';
import { publishDraft, discardDraft } from '../connection/generate-content';
import { GreenroomState as GRS } from '../stores/types/types';
import Socket from '../connection/socket';
import { setModalOpen } from '../stores/actions/modal';
import { clearDraftOverlays } from '../stores/actions/graphics';
import { clearDraftContent } from '../stores/actions/generate-content';
import { ContentServiceJobStatus } from '../stores/reducers/generate-content';

export const useCloseEditModal = () => {
	const dispatch = useDispatch();
	const meeting = useSelector((state: GRS) => state.SessionReducer.meeting);
	const token = useSelector((state: GRS) => state.SessionReducer.token);

	const closeEditModal = async (socket: Socket | null | undefined, doSave: boolean) => {
		socket?.disconnectEditListeners();
		if (token && meeting?.meeting) {
			if (doSave) {
				publishDraft(token, meeting.meeting);
			} else {
				discardDraft(token, meeting.meeting);
			}
		}
		dispatch(clearDraftOverlays());
		dispatch(clearDraftContent());
		dispatch(setShotModalShot(baseShot));
		dispatch(setModalOpen(false));
	};

	return closeEditModal;
};

export const useShotEditModalIsLocked = () => {
	const [didJustEdit, setDidJustEdit] = useState(false);
	const [isProcessing, setIsProcessing] = useState(false);

	const contentEdits = useSelector((s: GRS) => s.GeneratedContentReducer.generatedContentEdits);
	const shotModalShot = useSelector((s: GRS) => s.ShotsReducer.shotModalShot);
	const shotModalEditTimestamp = useSelector((s: GRS) => s.ShotsReducer.shotModalEditTimestamp);

	const editTimeout = useRef<NodeJS.Timeout>();

	useEffect(() => {
		if (shotModalEditTimestamp > 0) {
			clearTimeout(editTimeout.current);
			setDidJustEdit(true);
			setTimeout(() => {
				setDidJustEdit(false);
			}, 1000 * 2);
		}
	}, [shotModalEditTimestamp]);

	useEffect(() => {
		let anyProcessing = false;
		shotModalShot.shot_data.shotGraphics?.forEach((overlayId) => {
			const contentEdit = contentEdits.find((gc) => gc.fkId === overlayId);
			if (contentEdit?.jobStatus === ContentServiceJobStatus.processing) {
				anyProcessing = true;
			}
		});

		setIsProcessing(anyProcessing);
	}, [shotModalShot.shot_data.shotGraphics, contentEdits]);

	return (didJustEdit || isProcessing);
};

export default useCloseEditModal;
